import { useLocation } from 'react-router';

/**
 * Return address handed over to a detail/edit page so that its back link can
 * bring the user back to the very same list state (filters, page, sort).
 *
 * Pass the result as the `state` prop of the link that leaves the list.
 */
export const useListLocationState = () => {
  const location = useLocation();
  return { from: `${location.pathname}${location.search}` };
};
